// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    incidents_find_incidents: 'Buscando entre las incidencias',
    incidents_incidents_on: 'Mirando qué le pasa',
    incidents_report_incident: 'Apuntando una incidencia',
    incidents_resolve_incident: 'Cerrando una incidencia',
  },
  ca: {
    incidents_find_incidents: 'Cercant entre les incidències',
    incidents_incidents_on: 'Mirant què li passa',
    incidents_report_incident: 'Anotant una incidència',
    incidents_resolve_incident: 'Tancant una incidència',
  },
  en: {
    incidents_find_incidents: 'Looking through the incidents',
    incidents_incidents_on: 'Checking what is wrong with it',
    incidents_report_incident: 'Writing an incident down',
    incidents_resolve_incident: 'Closing an incident',
  },
  fr: {
    incidents_find_incidents: 'Recherche parmi les incidents',
    incidents_incidents_on: 'Ce qui ne va pas',
    incidents_report_incident: 'Enregistrement d’un incident',
    incidents_resolve_incident: 'Clôture d’un incident',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
